/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateStopDtoAddress } from './CreateStopDtoAddress';
import {
    CreateStopDtoAddressFromJSON,
    CreateStopDtoAddressFromJSONTyped,
    CreateStopDtoAddressToJSON,
    CreateStopDtoAddressToJSONTyped,
} from './CreateStopDtoAddress';
import type { CreateStopDtoCoordinates } from './CreateStopDtoCoordinates';
import {
    CreateStopDtoCoordinatesFromJSON,
    CreateStopDtoCoordinatesFromJSONTyped,
    CreateStopDtoCoordinatesToJSON,
    CreateStopDtoCoordinatesToJSONTyped,
} from './CreateStopDtoCoordinates';

/**
 * 
 * @export
 * @interface CreateStopDto
 */
export interface CreateStopDto {
    /**
     * Order index of the stop
     * @type {number}
     * @memberof CreateStopDto
     */
    index: number;
    /**
     * Title of the stop
     * @type {string}
     * @memberof CreateStopDto
     */
    title: string;
    /**
     * Optional image URL
     * @type {string}
     * @memberof CreateStopDto
     */
    imageUrl?: string;
    /**
     * Highlight text
     * @type {string}
     * @memberof CreateStopDto
     */
    highlight?: string;
    /**
     * Detailed description
     * @type {string}
     * @memberof CreateStopDto
     */
    description?: string;
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof CreateStopDto
     */
    startTime?: string;
    /**
     * Arrival time in HH:MM format
     * @type {string}
     * @memberof CreateStopDto
     */
    arrivalTime?: string;
    /**
     * Departure time in HH:MM format
     * @type {string}
     * @memberof CreateStopDto
     */
    departureTime?: string;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof CreateStopDto
     */
    durationMinutes?: number;
    /**
     * Travel time to this stop in minutes
     * @type {number}
     * @memberof CreateStopDto
     */
    travelTimeMinutes?: number;
    /**
     * State of the stop
     * @type {string}
     * @memberof CreateStopDto
     */
    state?: CreateStopDtoStateEnum;
    /**
     * Array of day IDs to associate with
     * @type {Array<string>}
     * @memberof CreateStopDto
     */
    dayIds?: Array<string>;
    /**
     * Mapbox ID of existing place (preferred)
     * @type {string}
     * @memberof CreateStopDto
     */
    mapboxId?: string;
    /**
     * Feature type from Mapbox (poi, address, locality, etc.)
     * @type {string}
     * @memberof CreateStopDto
     */
    featureType?: string;
    /**
     * Location query for place lookup/creation
     * @type {string}
     * @memberof CreateStopDto
     */
    locationQuery?: string;
    /**
     * 
     * @type {CreateStopDtoCoordinates}
     * @memberof CreateStopDto
     */
    coordinates?: CreateStopDtoCoordinates;
    /**
     * 
     * @type {CreateStopDtoAddress}
     * @memberof CreateStopDto
     */
    address?: CreateStopDtoAddress;
}


/**
 * @export
 */
export const CreateStopDtoStateEnum = {
    Suggested: 'SUGGESTED',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;
export type CreateStopDtoStateEnum = typeof CreateStopDtoStateEnum[keyof typeof CreateStopDtoStateEnum];


/**
 * Check if a given object implements the CreateStopDto interface.
 */
export function instanceOfCreateStopDto(value: object): value is CreateStopDto {
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CreateStopDtoFromJSON(json: any): CreateStopDto {
    return CreateStopDtoFromJSONTyped(json, false);
}

export function CreateStopDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateStopDto {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'title': json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'description': json['description'] == null ? undefined : json['description'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'arrivalTime': json['arrivalTime'] == null ? undefined : json['arrivalTime'],
        'departureTime': json['departureTime'] == null ? undefined : json['departureTime'],
        'durationMinutes': json['durationMinutes'] == null ? undefined : json['durationMinutes'],
        'travelTimeMinutes': json['travelTimeMinutes'] == null ? undefined : json['travelTimeMinutes'],
        'state': json['state'] == null ? undefined : json['state'],
        'dayIds': json['dayIds'] == null ? undefined : json['dayIds'],
        'mapboxId': json['mapboxId'] == null ? undefined : json['mapboxId'],
        'featureType': json['featureType'] == null ? undefined : json['featureType'],
        'locationQuery': json['locationQuery'] == null ? undefined : json['locationQuery'],
        'coordinates': json['coordinates'] == null ? undefined : CreateStopDtoCoordinatesFromJSON(json['coordinates']),
        'address': json['address'] == null ? undefined : CreateStopDtoAddressFromJSON(json['address']),
    };
}

  export function CreateStopDtoToJSON(json: any): CreateStopDto {
      return CreateStopDtoToJSONTyped(json, false);
  }

  export function CreateStopDtoToJSONTyped(value?: CreateStopDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'highlight': value['highlight'],
        'description': value['description'],
        'startTime': value['startTime'],
        'arrivalTime': value['arrivalTime'],
        'departureTime': value['departureTime'],
        'durationMinutes': value['durationMinutes'],
        'travelTimeMinutes': value['travelTimeMinutes'],
        'state': value['state'],
        'dayIds': value['dayIds'],
        'mapboxId': value['mapboxId'],
        'featureType': value['featureType'],
        'locationQuery': value['locationQuery'],
        'coordinates': CreateStopDtoCoordinatesToJSON(value['coordinates']),
        'address': CreateStopDtoAddressToJSON(value['address']),
    };
}

